import {
  NodeUtils,
  createBlock,
  mergeBlock,
  t,
} from "@easy-email-pro-core/utils";

import { BasicType, ElementCategory } from "@easy-email-pro-core/constants";
import {
  WrapperWidgetElement,
  ElementDefinition,
} from "@easy-email-pro-core/typings";
import React from "react";
import { BlockRenderer, Wrapper } from "@easy-email-pro-core/components";

const defaultData: ElementDefinition<WrapperWidgetElement>["defaultData"] = {
  attributes: {},
  data: {
    description: "",
    config: [],
    input: {},
  },
};

export const WrapperWidget = createBlock<WrapperWidgetElement>({
  get name() {
    return t("Widget");
  },
  void: true,
  defaultData,
  type: BasicType.WRAPPER_WIDGET,
  create: (payload) => {
    const data: WrapperWidgetElement = {
      type: BasicType.WRAPPER_WIDGET,
      title: "MY FIRST WIDGET",
      data: {
        ...defaultData.data,
      },
      attributes: {},
      children: [{ text: "" }],
    };
    return mergeBlock(data, payload);
  },
  get category() {
    return ElementCategory.WRAPPER;
  },
  render(params) {
    const { node } = params;

    return (
      <Wrapper padding="0px">
        {node.children.map((item) => {
          if (!NodeUtils.isElement(item)) return null;
          return <BlockRenderer {...params} node={item} />;
        })}
      </Wrapper>
    );
  },
});
